import type { FC } from 'react';

import { Button } from '@cuc/ui/kit';

import type { LoginButtonProps } from './types';

export const LoginButton: FC<LoginButtonProps> = ({ onClick }) => (
  <Button variant="primary" onClick={onClick}>
    Log in
  </Button>
);
